import { safeDefineFsComponent } from '@cof/safe-custom-element-define';
import { FsTextField as TextField } from './src/index.js';
const { customElementClass, safeTagName } = safeDefineFsComponent.define(TextField);
export const FsTextField = customElementClass;
export const tagName = safeTagName;
//# sourceMappingURL=fs-text-field.js.map